import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Translate from '../../../utils/Translate';
import Header from '../Header/Header';
import Alert from '../Alert/Alert';
import { VerifyEmailContainer } from './VerifyEmail/VerifyEmailContainer';
import { ConfirmMergeContainer } from './ConfirmMerge/ConfirmMergeContainer';
import { MergeAccountSuccess } from './MergeAccountSuccess/MergeAccountSuccess';

import { PERSONAL_INFO } from '../../../utils/Pages';

import './AddEmailPage.css';
import { EmailStore } from '../../../state/EmailStore';
import { MergeTiersAndPointsContainer } from './MergeTiersAndPoints/MergeTiersAndPointsContainer';
import { MergeLoyaltySummaryContainer } from './MergeLoyaltySummary/MergeLoyaltySummaryContainer';

const showScreen = (
  currentStep,
  isCancelEnabled,
  errorMessage,
  setErrorMessage,
  nextButtonClick
) => {
  if (currentStep === 0) {
    return (<VerifyEmailContainer
      isCancelEnabled={isCancelEnabled}
      onNextButtonClick={nextButtonClick}
      onError={setErrorMessage}
    />);
  } else if (currentStep === 1) {
    if (EmailStore.hasReminder()) {
      return (<ConfirmMergeContainer
        isCancelEnabled={isCancelEnabled}
        onConfirmButtonClick={nextButtonClick}
        onError={setErrorMessage}
      />);
    }
    // if it doesn't have reminder then we show MergeAccountSuccess
  } else if (currentStep === 2) {
    if (EmailStore.isBothLoyaltyAccounts()) {
      return (<MergeTiersAndPointsContainer
        onConfirmButtonClick={nextButtonClick}
        onError={setErrorMessage}
      />);
    }
    // if both accounts aren't loyalty we show MergeAccountSuccess
  } else if (currentStep === 3) {
    return (<MergeLoyaltySummaryContainer
      onConfirmButtonClick={nextButtonClick}
      onError={setErrorMessage}
    />);
  }

  return (<MergeAccountSuccess/>);
};

export const AddEmailPage = withRouter(() => {
  const [currentStep, setCurrentStep] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  const [titleMessageKey, setTitleMessageKey] = useState('add-email-page.header.step.0.title');
  const [subtitleMessageKey, setSubtitleMessageKey] = useState('');
  const steps = 4; // TODO: this should be dynamic

  const nextButtonClick = () => {
    setCurrentStep(currentStep + 1);
  };


  // TODO: This could be improved
  useEffect(() => {
    if (EmailStore.hasReminder()) {
      if (currentStep === 1) {
        setTitleMessageKey(`add-email-page.header.step.${EmailStore.getLoyaltyMergeStatus()}.title`);
        setSubtitleMessageKey(`add-email-page.header.step.${EmailStore.getLoyaltyMergeStatus()}.subtitle`);
      } else if (currentStep === 2) {
        setTitleMessageKey(`add-email-page.header.step.${EmailStore.getLoyaltyMergeStatus()}.title`); // check if this is necessary
        setSubtitleMessageKey('');
      } else if (currentStep === 3) {
        setTitleMessageKey('add-email-page.header.step.3.title');
      }
    }
    setTitleMessageKey('');
  }, [currentStep]);

  const isCancelEnabled = currentStep < steps; // TODO: is this necessary?

  return (
    <div className="eva-3-dashboard-aftersale -eva-3-mb-xlg -eva-3-tc-gray-1 -eva-3-bc-gray-7">
      <Header
        name={Translate.message(titleMessageKey)}
        subtitle={Translate.message(subtitleMessageKey)}
        page={PERSONAL_INFO}
      />
      <div className="eva-3-container -eva-3-bc-gray-7 -p-0 -p-md-2 -pb-md-4 -pl-md-5 -pr-md-5 -pt-4">
        <div className="dashboard-aftersale-results-container eva-3-row -no-gutter">
          <div className="col -sm-12 -lg-8">
            <div className="addEmailPage-container">
              {
                errorMessage &&
                <Alert className="-eva-3-mb-lg" type="error">
                  {errorMessage}
                </Alert>
              }

              {showScreen(
                currentStep,
                isCancelEnabled,
                errorMessage,
                setErrorMessage,
                nextButtonClick,
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
